// Confirmações — fila de consultas aguardando confirmação + transições (API real).
// Cutover Fatia 2: fala com /clinica/confirmations (list/confirm/cancel) e
// /clinica/reschedules (toReschedule cria o pedido). Adapta o payload canônico
// do backend para o shape que a view consome (initials/avatarClass/when).
import AXIOS from "@/services/axios";
import { initialsOf, avatarClassFor, slotLabel } from "./helpers";

function adaptConfirmation(c, i) {
  const patient = c.patient || {};
  return {
    id: c.id,
    patientId: patient.id,
    patientName: patient.name,
    phone: patient.phone,
    initials: initialsOf(patient.name),
    avatarClass: avatarClassFor(i),
    doctorName: c.doctor_name,
    when: slotLabel(c.scheduled_at),
    scheduledAt: c.scheduled_at, // data crua para contagens hoje/amanhã/semana
    status: "aguardando_confirmacao"
  };
}

export class ClinicConfirmations {
  static list() {
    return AXIOS.get("clinica/confirmations").then(res => ({
      data: (res.data || []).map(adaptConfirmation)
    }));
  }

  /** Dispara lembretes (WhatsApp + SMS) para todos os pacientes da fila. */
  static remindAll() {
    return AXIOS.post("clinica/confirmations/remind");
  }

  /** Confirma a consulta. */
  static confirm(id) {
    return AXIOS.post(`clinica/confirmations/${id}/confirm`).then(() => ({
      data: { id, status: "confirmada" }
    }));
  }

  /** Cancela a consulta (endpoint escopado à clínica). */
  static cancel(id) {
    return AXIOS.post(`clinica/confirmations/${id}/cancel`).then(() => ({
      data: { id, status: "cancelada" }
    }));
  }

  /** Envia para reagendamento → cria um RescheduleRequest para a consulta. */
  static toReschedule(id) {
    return AXIOS.post("clinica/reschedules", { appointment_id: id }).then(
      res => ({
        data: { id, movedTo: "reschedules", request: res.data }
      })
    );
  }
}

export default ClinicConfirmations;
